





























import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import {DateTime, MonthCountStat} from "@/modules/models";
import {SecondaryColor, UnimportantColor} from "@/modules/constants";
import InfoBtn from "@/components/shared/InfoBtn.vue";
import InfoDialog from "@/components/InfoDialog.vue";

@Component({
    components: {
        "at-info-btn": InfoBtn,
        "at-info-dialog": InfoDialog,
    }
})
export default class MonthlyCount extends CommonBase {
    @Prop({default: () => []})
    value!: MonthCountStat[];
    @Prop()
    title!: string;
    @Prop({default: "trend"})
    type!: string;
    @Prop({default: () => []})
    gradient!: string[];

    readonly color = SecondaryColor;

    showExpanded = false;
    showInfo = false;

    get counts () {
        return this.value.map(r => r.count);
    }
    get latestCount() {
        const l = this.value.length;
        if(l > 0) {
            return this.value[l - 1].count;
        }
        return 0;
    }

    formatMonth(dt: DateTime) {
        return dt.monthName() + " " + dt.year();
    }
}
